import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useDeliveryRatesLogic = () => {
  const apiRoute = "deliveryrates";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "address",
      label: "Address",
      type: "text",
      isRequired: true,
      err: "Address is required",
      disableEditForNonAdmin: true,
    },
    {
      name: "season",
      label: "Season",
      type: "dropdown",
      isRequired: true,
      err: "Season is required",
      returnID: true,
      disableEditForNonAdmin: true,
    },
    {
      name: "currency",
      label: "Currency",
      type: "dropdown",
      isRequired: false,
      err: "Currency is required",
      disabled: true,
      returnID: true,
      defaultsTo: "season.branch.currency.id",
      placeholder: "Season's branch currency",
    },
    {
      name: "rate",
      label: "Rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Rate is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(
        config,
        "seasons",
        "season",
        temp,
        "Name",
        "branch"
      ),
      fetchDataAndMapToField(
        config,
        "currencies",
        "currency",
        temp,
        "code",
        "symbol"
      ),
    ];
  };
  return {
    apiRoute,
    onlyForm,
    initFields,
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
  };
};

export default useDeliveryRatesLogic;
